import { useMemo, type ReactNode } from "react";
import { areaChartSpec, type AreaChartSpecOptions } from "../specs/area.js";
import type { ChartData } from "../types.js";
import { VegaChart } from "./VegaChart.js";
import type { ChartContainerProps } from "./shared.js";

export interface AreaChartProps
  extends AreaChartSpecOptions, ChartContainerProps {
  data: ChartData;
}

/** A themed area chart. Pass `color` for stacked/overlaid series. */
export function AreaChart({
  data,
  x,
  y,
  xType,
  yType,
  color,
  colorType,
  stack,
  interpolate,
  point,
  xTitle,
  yTitle,
  title,
  subtitle,
  ...container
}: AreaChartProps): ReactNode {
  const spec = useMemo(
    () =>
      areaChartSpec({
        data,
        x,
        y,
        xType,
        yType,
        color,
        colorType,
        stack,
        interpolate,
        point,
        xTitle,
        yTitle,
        title,
        subtitle,
      }),
    [
      data,
      x,
      y,
      xType,
      yType,
      color,
      colorType,
      stack,
      interpolate,
      point,
      xTitle,
      yTitle,
      title,
      subtitle,
    ],
  );

  return <VegaChart spec={spec} {...container} />;
}
